import { useContext } from 'react';
import { OverlayContext } from '../../../providers/OverlayContextProvider';
/**
 * Seagull-internal access to the managed sheet stack, kept off the package barrel so a feature
 * cannot reach it. Consumers outside seagull open overlays with showModal.
 *
 * @deprecated Imperative sheet stack, retired in favour of showModal (ANCR-3039). Do not add callers.
 */ export function useSheetStack() {
    return useContext(OverlayContext);
}
